import React from "react";

// reactstrap components
import {
    Table,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap";
import CreditCategoryDataService from "../../services/CreditCategoryDataService";

class CreditCategories extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.CreditCategoryDataService = new CreditCategoryDataService();
    }

    toggleModal = (creditCategory) => {
        this.props.toggleModal("formModal", "edit", creditCategory)
    }

    toggleModals = (state, creditCategory) => {
        this.setState({
          [state]: !this.state[state],
          creditCategoryToDisabled: creditCategory,
        });
    };

    handleDisableCreditCategory() {
        this.CreditCategoryDataService.disable(this.state.creditCategoryToDisabled)
            .then((data) => {
                this.handleResponse(data, "Produk berhasil dinonaktifkan");
            });
    }

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
              return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.toggleModals("notificationModal")
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentCreditCategory: {}})
            this.props.fetchData()
        }
    }

    render() {
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                <tr>
                    <th scope="col">ID kategori</th>
                    <th scope="col">Nama kategori</th>
                    <th scope="col" />
                </tr>
                </thead>
                <tbody>
                {this.props.creditCategories.length > 0 && this.props.creditCategories.filter(creditCategory => creditCategory).map((creditCategory) => (
                    <tr style={{cursor: 'pointer'}}>
                    <th scope="row" onClick={() => this.toggleModal(creditCategory)}>
                        {creditCategory.category_id}
                    </th>
                    <td onClick={() => this.toggleModal(creditCategory)}>
                        {creditCategory.category_name}
                    </td>
                    <td className="text-right">
                        <UncontrolledDropdown>
                        <DropdownToggle
                            className="btn-icon-only text-light"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                        >
                            <i className="fas fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem
                            onClick={() => this.toggleModal(creditCategory)}
                            >
                            Ubah
                            </DropdownItem>
                        </DropdownMenu>
                        </UncontrolledDropdown>
                    </td>
                    </tr>
                ))}
                </tbody>
            </Table>
        )
    };
}

export default CreditCategories;
